<bzg-modal-header>
  <div class="bmc-view-differences__header">
    <span>{{ 'VIEW_DELTA.COMPARE_CONTENT' | translate }}</span>
    <div class="bmc-view-differences__actions">
      <bzg-modal-fullscreen></bzg-modal-fullscreen>
      <bzg-button-icon icon="icon-close" (click)="close()"></bzg-button-icon>
    </div>
  </div>
</bzg-modal-header>
<bzg-modal-content>
  <div class="bmc-view-differences__content">
    <ngx-monaco-diff-editor
      (onInit)="onDiffInit($event)"
      [options]="options"
      [originalModel]="dataCompare.originalModel"
      [modifiedModel]="dataCompare.modifiedModel"
      class="diff-editor">
    </ngx-monaco-diff-editor>
    <div class="diff-overlay" *ngIf="isLoadingDiff">
      <div class="bz-loading-container">
        <bz-loading [size]="'l'"></bz-loading>
      </div>
    </div>
  </div>
</bzg-modal-content>
<bzg-modal-footer>
  <bzg-button-secondary (click)="close()">{{ 'VIEW_DELTA.CLOSE' | translate }}</bzg-button-secondary>
</bzg-modal-footer>
